<section class="task-agent-hitl mb-6" aria-labelledby="agent-run-heading">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h4 id="agent-run-heading" class="mb-0">Agent Run</h4>
    <button
      type="button"
      class="btn btn-sm btn-light"
      [disabled]="loading"
      (click)="refresh()"
      aria-label="Refresh Agent Run status"
    >
      Refresh
    </button>
  </div>

  <p>
    Status:
    <strong [attr.aria-live]="'polite'">{{ statusLabel }}</strong>
  </p>
  <p *ngIf="!runId" class="text-muted mb-0">No agent run is linked to this step yet.</p>
  <p *ngIf="loading" role="status">Loading Agent Run status...</p>
  <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }}</div>

  <ng-container *ngIf="!loading && run">
    <p *ngIf="pending" class="text-muted">
      Agent Run is {{ outcome }}.
      <span *ngIf="outcome === 'Waiting'">No decision is required yet.</span>
      <span *ngIf="outcome === 'HumanInputRequired' && canDecide">
        Review the proposal below, then approve or deny the complete action.
      </span>
      <span *ngIf="outcome === 'HumanInputRequired' && !canDecide">
        The agent needs manual assistance; no approval is pending.
      </span>
      <span *ngIf="outcome === 'Escalated'">This run is escalated.</span>
    </p>
    <p *ngIf="skillName">Pending skill: {{ skillName }}</p>
    <div *ngIf="canDecide" class="mt-3">
      <section
        *ngIf="email as proposedEmail"
        class="email-preview mb-4"
        aria-labelledby="proposed-email-heading"
      >
        <h5 id="proposed-email-heading">Proposed patient email</h5>
        <dl class="mb-0">
          <dt>Recipient</dt>
          <dd>Patient linked to this task</dd>
          <dt>Subject</dt>
          <dd class="email-subject">{{ proposedEmail.subject }}</dd>
          <dt>Body</dt>
          <dd class="email-body">{{ proposedEmail.body }}</dd>
        </dl>
      </section>
      <div *ngIf="isEmailSkill && !email" class="alert alert-danger" role="alert">
        The proposed email is unavailable. You can deny this action, but it cannot be approved.
      </div>
      <label for="hitl-reason" class="d-block">Reason (optional)</label>
      <textarea
        id="hitl-reason"
        class="form-control mb-3"
        rows="2"
        maxlength="500"
        [(ngModel)]="reason"
        [ngModelOptions]="{ standalone: true }"
        name="hitlReason"
      ></textarea>
      <button
        type="button"
        class="btn btn-success mr-2"
        [disabled]="!canApprove || deciding"
        (click)="decide('approve')"
        aria-label="Approve outbound skill"
      >
        Approve
      </button>
      <button
        type="button"
        class="btn btn-danger"
        [disabled]="deciding"
        (click)="decide('deny')"
        aria-label="Deny outbound skill"
      >
        Deny
      </button>
    </div>
  </ng-container>
</section>
